var getAddressComponentType, getAlternateAddressFormat;

getAddressComponentType = function(arg, component_type) {
  var address_components;
  address_components = arg.address_components;
  return _.find(address_components, function(arg1) {
    var types;
    types = arg1.types;
    return _.some(types, function(type) {
      return type === component_type;
    });
  });
};

getAlternateAddressFormat = function(result) {
  var ref, ref1, ref2;
  if (getAddressComponentType(result, 'sublocality_level_1') != null) {
    return (ref = getAddressComponentType(result, 'sublocality_level_1')) != null ? ref.short_name : void 0;
  } else if (getAddressComponentType(result, 'locality') != null) {
    return (ref1 = getAddressComponentType(result, 'locality')) != null ? ref1.long_name : void 0;
  } else if (getAddressComponentType(result, 'administrative_area_level_1') != null) {
    return (ref2 = getAddressComponentType(result, 'administrative_area_level_1')) != null ? ref2.short_name : void 0;
  } else {
    return result.formatted_address;
  }
};

module.exports = {
  getAddressComponentType: getAddressComponentType,
  getAlternateAddressFormat: getAlternateAddressFormat
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9nZW5lcmFsL3NwZWNpYWxBZGRyZXNzQ29tcG9uZW50VHlwZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL2dlbmVyYWwvc3BlY2lhbEFkZHJlc3NDb21wb25lbnRUeXBlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxJQUFBOztBQUFBLHVCQUFBLEdBQTBCLFNBQUMsR0FBRCxFQUF1QixjQUF2QjtBQUN4QixNQUFBO0VBRDBCLHFCQUFEO1NBQ3pCLENBQUMsQ0FBQyxJQUFGLENBQU8sa0JBQVAsRUFBMkIsU0FBQyxJQUFEO0FBQ3pCLFFBQUE7SUFEMkIsUUFBRDtXQUMxQixDQUFDLENBQUMsSUFBRixDQUFPLEtBQVAsRUFBYyxTQUFDLElBQUQ7YUFBVSxJQUFBLEtBQVE7SUFBbEIsQ0FBZDtFQUR5QixDQUEzQjtBQUR3Qjs7QUFJMUIseUJBQUEsR0FBNEIsU0FBQyxNQUFEO0FBQzFCLE1BQUE7RUFBQSxJQUFHLDhEQUFIO3VGQUN3RCxDQUFFLG9CQUQxRDtHQUFBLE1BRUssSUFBRyxtREFBSDs4RUFDd0MsQ0FBRSxtQkFEMUM7R0FBQSxNQUVBLElBQUcsc0VBQUg7aUdBQzJELENBQUUsb0JBRDdEO0dBQUEsTUFBQTtXQUdILE1BQU0sQ0FBQyxrQkFISjs7QUFMcUI7O0FBVTVCLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2YseUJBQUEsdUJBRGU7RUFFZiwyQkFBQSx5QkFGZSJ9
